import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import PropTypes from 'prop-types';
import messages from '../messages';

export const CancelButton = ({ setIdInEditMode, setErrorMessage }) => {
  const onClickCallback = useCallback(() => {
    setIdInEditMode(null);
    setErrorMessage(null);
  }, [setIdInEditMode, setErrorMessage]);

  return (
    <Button onClick={onClickCallback} theme='link'>
      <FormattedMessage {...messages.cancelCategoryEditButton} />
    </Button>
  );
};

CancelButton.propTypes = {
  setIdInEditMode: PropTypes.func.isRequired,
  setErrorMessage: PropTypes.func.isRequired,
};
